module.exports = __webpack_public_path__ + "static/media/bg-card_product-education.7f5d3680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bg/bg-card_product-education.jpg
// module id = 1497
// module chunks = 0